export default __webpack_public_path__ + "assets/onboarding-screen.04f96908.svg";